import { DELETE, UPDATE } from '../mutation-types'
import TypeNames from '../../services/Typenames'

// This plugin is a singleton. This would otherwise be a leak
export const updateFuncs = {}

function listenForChangesForType(typename, store) {
  updateFuncs[typename] = {
    update(updatedItem) {
      store.commit(typename + '/' + UPDATE, { data: updatedItem })
    },
    delete(deletedId) {
      store.commit(typename + '/' + DELETE, { id: deletedId })
    }
  }
}

export default function createDbCachePlugin() {
  return (store: any) => {
    store.subscribeAction(() => {
      Object.values(TypeNames).forEach(type => {
        if (!updateFuncs[type]) {
          listenForChangesForType(type, store)
        }
      })
    })
  }
}
